<template>
  <div class="div-dias-semana">
    <span class="text-datas-number ml-12">
      {{ qtLotesAlocadosConfirmados }}
    </span>
    <span class="text-datas-extenso ml-1 mr-1">de</span>
    <span class="text-datas-number mr-12">{{ listaLotesFiltrada.length }}</span>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "CardItemLoteAlocadoConfirmado",
  props: {
    itemData: {
      type: Object,
      default: {}
    },
    itemPlanta: {
      type: Object,
      default: {}
    },
    listaLotesFiltradaDataPlanta: {
      type: Object
    }
  },
  computed: {
    ...mapState("programacaoAbate", [
      "programacaoAbateSelected",
      "listBatchsAllocated"
    ]),
    listaLotesFiltrada() {
      if (this.listBatchsAllocated) {
        let context = this;
        let listaFiltrada = this.listBatchsAllocated
          .filter(x => x.cdPlantaAbate == this.itemPlanta.cdPlantaAbate)
          .filter(y => y.stDiaAlocado == this.itemData.value);

        return listaFiltrada;
      }
      return [];
    },
    qtLotesAlocadosConfirmados() {
      let listPreenchida = [];
      for (const key in this.listaLotesFiltradaDataPlanta) {
        if (key != "null") {
          let itemsData = this.listaLotesFiltradaDataPlanta[key][
            this.itemData.text
          ];
          itemsData.forEach(lote => {
            listPreenchida.push(lote);
          });
        }
      }
      return listPreenchida.length;
    }
  },
  data() {
    return {};
  },
  methods: {}
};
</script>
